var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.486,
    height: 18.934,
    viewBox: "0 0 20.486 18.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "inventory (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21868"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16439",
    d: "M19.321 3.267a.636.636 0 0 0-.477-.2h-5.763a.673.673 0 0 0-.681.674v6.11h7.124V3.744a.693.693 0 0 0-.2-.477zm-2.876 2.544h-.973a.681.681 0 0 1 0-1.355h.973a.681.681 0 0 1 0 1.355z",
    transform: "translate(-5.719 -3.07)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16440",
    d: "M6.411 15.87a.674.674 0 0 0-.681.674v5.432h7.124V15.87zm3.365 2.71h-.967a.681.681 0 1 1 0-1.355h.967a.681.681 0 1 1 0 1.355z",
    transform: "translate(-3.292 -7.728)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16441",
    d: "M26.022 16.067a.674.674 0 0 0-.477-.2H19.07v6.106h7.124v-5.429a.693.693 0 0 0-.172-.477zm-2.881 2.513h-1a.681.681 0 1 1 0-1.355h.967a.681.681 0 1 1 0 1.355z",
    transform: "translate(-8.147 -7.728)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16442",
    d: "M21.636 27.6H2.643a.681.681 0 1 0 0 1.355h2.035v1.361a.681.681 0 0 0 1.355 0v-1.363h12.213v1.361a.681.681 0 0 0 1.355 0v-1.361h2.035a.681.681 0 1 0 0-1.355z",
    transform: "translate(-1.897 -11.995)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/_inventory.2077b7ba569beb6b24f5ec5af8c8bdc1.svg";
export { ForwardRef as ReactComponent };